export default function checkIfAddressesAreEqual(billingAddress = {}, shippingAddress = {}) {
  if (billingAddress === shippingAddress) {
    return true;
  }

  // If either is not an object or is null, they are not equal
  if (
    typeof billingAddress !== 'object' ||
    billingAddress === null ||
    typeof shippingAddress !== 'object' ||
    shippingAddress === null
  ) {
    return false;
  }

  const billingAddressKeys = Object.keys(billingAddress);
  const shippingAddressKeys = Object.keys(shippingAddress);

  // If the number of keys is different, they are not equal
  if (billingAddressKeys.length !== shippingAddressKeys.length) {
    return false;
  }

  // Check if all keys in billingAddress are present in shippingAddress and that their values are equal
  for (const key of billingAddressKeys) {
    if (
      !shippingAddressKeys.includes(key) ||
      !checkIfAddressesAreEqual(billingAddress[key], shippingAddress[key])
    ) {
      return false;
    }
  }

  if (Array.isArray(billingAddress) && Array.isArray(shippingAddress)) {
    if (billingAddress.length !== shippingAddress.length) {
      return false;
    }
    // Recursively compare each element of the arrays
    for (let i = 0; i < billingAddress.length; i++) {
      if (!checkIfAddressesAreEqual(billingAddress[i], shippingAddress[i])) {
        return false;
      }
    }
    return true;
  }
  return true;
}
